// Must be kept in sync with Azure Function code
// @see: https://dev.azure.com/bluegrace-vsts/Nebula/_git/BS.RateQuality?path=/BS.RateQuality.Functions/BatchRates/Entities
export const COLUMN_NAMES = {
  DATE_RANGE: { FROM_DATE: 'From Date', TO_DATE: 'To Date' },
  EMAIL_RECIPIENTS: 'Email Recipients',
  AUTO_RATE_SHIPMENTS: 'Auto Rate Shipments',
} as const;
